export { default as ArrowRightSolidIcon } from './ArrowRightSolidIcon';
